module.exports = __webpack_public_path__ + "img/rewards75.a60ae5c.svg";